import { render, staticRenderFns } from "./EditSpending.vue?vue&type=template&id=36e3ed12&"
import script from "./EditSpending.vue?vue&type=script&lang=js&"
export * from "./EditSpending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports